class LocationChangeAdapter {
  constructor (pgConnection) {
    this.limit = 500
    this.pgConnection = pgConnection
  }

  /**
   * @param {string} page
   * @param {number} limit
   */
  getFilter (page, limit) {
    const parsedPage = parseInt(`${page}`)
    return {
      offset: page && Number.isInteger(parsedPage) && parsedPage > 0
        ? ` offset ${(parsedPage - 1) * limit} `
        : '',
      limit,
      page: page && Number.isInteger(parsedPage) && parsedPage > 0
        ? parsedPage
        : 1
    }
  }

  /**
   * @param {Object} param
   * @param {number} param.fromLevel
   * @param {string} param.fromSequence
   * @param {boolean} param.hasOrdersStatus
   * @param {string} param.pageNumber
   * @param {number} param.rowLimit
   * @returns {Promise<{
   *   results: {
   *     seq: number
   *     location_id: string
   *     new_val: any
   *     updated_at: string
   *   }[]
   *   maxSequence: number
   *   page: number
   *   count: number
   * }>}
   */
  async get ({
    fromLevel,
    fromSequence,
    hasOrdersStatus,
    pageNumber,
    rowLimit
  }) {
    let queryFilter = ``
    const values = []

    if (fromLevel) {
      queryFilter = queryFilter.concat(` ${values.length ? 'and' : ''} level::integer >= $${values.length + 1} `)
      values.push(fromLevel)
    }

    if (fromSequence) {
      queryFilter = queryFilter.concat(` ${values.length ? 'and' : ''} trigger_update_seq > $${values.length + 1} `)
      values.push(fromSequence)
    }

    if (hasOrdersStatus) {
      queryFilter = queryFilter.concat(` ${values.length ? 'and' : ''} orders_status is not null `)
    }

    const { page, limit, offset } = this.getFilter(pageNumber, rowLimit || this.limit)

    let query = `
      with changes as (
        select
          l.uuid as location_id,
          l.trigger_updated_at as updated_at,
          row_to_json(l.*)::jsonb as new_val,
          l.trigger_update_seq as seq
        from avocado.data_location l
        ${queryFilter.length ? `where ${queryFilter}` : ''}
        order by seq
        limit ${limit} ${offset}
      )
      select
        coalesce(
          (
            select jsonb_agg(c)
            from (
              select
                *
              from changes
            ) c
          ),
          '[]'::jsonb
        ) as results,
        ${page} as page,
        coalesce((select count(1)::integer from changes), 0) as count,
        coalesce((select max(seq) from changes)) as "maxSequence"
    `

    const { rows } = await this.pgConnection.query(query, values)
    const result = rows[0]
    return result
  }
}

module.exports = LocationChangeAdapter
